import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import FormTextArea from '@/shared/components/forms/FormTextArea';
import Button from '@/shared/components/ui/Button';
import Modal from '@/shared/components/ui/Modals/Modal';

interface IMaintenanceModalProps {
  isOpen: boolean;
  deviceName: string;
  orgName?: string | null;
  onClose: () => void;
  onSubmit: (notes: string) => Promise<boolean>;
}

interface IMaintenanceForm {
  notes: string;
}

const MaintenanceModal = ({
  isOpen,
  deviceName,
  orgName,
  onClose,
  onSubmit,
}: IMaintenanceModalProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<IMaintenanceForm>({ defaultValues: { notes: '' } });

  useEffect(() => {
    if (isOpen) {
      reset({ notes: '' });
    }
  }, [isOpen, reset]);

  const onValid = async (data: IMaintenanceForm) => {
    const ok = await onSubmit(data.notes.trim());
    if (ok) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title='Put Device in Maintenance' size='md'>
      <form onSubmit={handleSubmit(onValid)} className='p-6'>
        <p className='text-sm text-gray-500 mb-4'>
          Device: <strong>{deviceName}</strong>
          {orgName
            ? ` · Currently rented to ${orgName} — the device stays reserved and billing pauses during maintenance.`
            : ''}
        </p>
        <FormTextArea
          name='notes'
          label='Reason'
          placeholder='Describe the issue...'
          register={register}
          errors={errors}
          rows={4}
          showRequiredMark={false}
        />
        <div className='flex justify-end gap-3 mt-6'>
          <Button type='button' variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button type='submit' variant='primary' isLoading={isSubmitting}>
            Put in Maintenance
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default MaintenanceModal;
